import { useActiveSyndicates } from "@/hooks/useActiveSyndicates";
import { useUniqueSyndicateMembersCount } from "@/hooks/useUniqueSyndicateMembersCount";
import { useHomepageHorseCount } from "@/hooks/useHomepageHorseCount";
import { Users, Sparkles, Database, Newspaper } from "lucide-react";

export const SocialProofBar = () => {
  const { data: members = 0 } = useUniqueSyndicateMembersCount();
  const { data: syndicates = [] } = useActiveSyndicates();
  const { data: horseCount = 0 } = useHomepageHorseCount();

  const horsesInSyndicates = syndicates?.length ?? 0;

  const stats = [
    {
      icon: Users,
      value: members > 0 ? `${members}+` : "—",
      label: "spolumajitelů",
    },
    {
      icon: Sparkles,
      value: horsesInSyndicates > 0 ? `${horsesInSyndicates}` : "—",
      label: horsesInSyndicates === 1 ? "kůň se spolumajitelstvím" : "koní se spolumajitelstvím",
    },
    {
      icon: Database,
      value: horseCount > 0 ? `${horseCount.toLocaleString("cs-CZ")}` : "—",
      label: "koní v databázi",
    },
    {
      icon: Newspaper,
      value: "Deník.cz · iSport",
      label: "psali o nás",
      isText: true,
    },
  ];

  return (
    <section
      aria-label="Fakta o Horsebeat"
      className="mb-2 md:mb-3 rounded-2xl bg-primary text-primary-foreground overflow-hidden"
    >
      <div className="grid grid-cols-2 md:grid-cols-4 divide-y-0 md:divide-x divide-white/10">
        {stats.map((s, i) => (
          <div
            key={i}
            className={`flex items-center gap-3 px-4 py-4 md:px-5 md:py-4 ${
              i < 2 ? "border-b md:border-b-0 border-white/10" : ""
            } ${i === 0 ? "border-r md:border-r-0 border-white/10" : ""} ${
              i === 2 ? "border-r md:border-r-0 border-white/10" : ""
            }`}
          >
            <div className="shrink-0 p-2 rounded-lg bg-white/10">
              <s.icon className="h-4 w-4 md:h-5 md:w-5 text-accent" />
            </div>
            <div className="min-w-0">
              <div
                className={`font-display font-semibold leading-tight ${
                  s.isText ? "text-sm md:text-base" : "text-lg md:text-2xl"
                }`}
              >
                {s.value}
              </div>
              <div className="text-[11px] md:text-xs text-primary-foreground/70 leading-snug">
                {s.label}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SocialProofBar;
